module.exports = __webpack_public_path__ + "img/no_banner.bef07521.jpg";